import {ProductInterface as CatalogProductInterface} from "../interfaces/catalog/ProductInterface";
import {useContext} from "react";
import {ReducerStateInterface} from "../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../GlobalReducer";
import {ProductInterface} from "../interfaces/product/ProductInterface";

export default function useComparison(product: CatalogProductInterface | ProductInterface) {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);


    const inComparison = () => {
        return state.comparison.map((item: CatalogProductInterface|ProductInterface) => item.id).includes(product.id);
    }

    const toggleComparison = () => {
        if (inComparison()) {
            dispatch({type: ReducerActionType.REMOVE_FROM_COMPARISON, payload: product});
        } else {
            dispatch({type: ReducerActionType.ADD_TO_COMPARISON, payload: product});
        }
    }

    return {inComparison, toggleComparison}
}